import styled from "styled-components/macro";

export const StyledText = styled.p``;

export const StyledLink = styled.a``;

export const StyledListItem = styled.li`
  margin-bottom: 1em;
`;

export const StyledModalContent = styled.div`
  max-width: 1200px;
  height: 100%;
  overflow-y: auto;
  padding: 3em;
`;

export const StyledTitle = styled.h1`
  line-height: 1em;
`;

export const StyledSubTitle = styled.h2`
  margin-top: 1.5em;
  line-height: 1em;
`;

export const StyledExitButton = styled.button`
  position: absolute;
  right: 1em;
  top: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin: 1em;
  padding: 0;
`;
